<template>
  <div>
    <div class="searchBox">
      <div class="searchLeft">
        <el-input
          size="medium"
          v-model="searchForm.userId"
          type="text" @input="searchForm.userId = String(searchForm.userId).replace(/[^\d]/g,'')"   ng-pattern="/[^a-zA-Z]/"
          placeholder="请输入用户ID"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-input
          size="medium"
          v-model="searchForm.phone"
          placeholder="请输入手机号"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-input
          size="medium"
          v-model="searchForm.email"
          placeholder="请输入邮箱"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
        <a :href="url+'/web/agent/agentStatisticsHistory/export?phone='+searchForm.phone + '&&userId='+searchForm.userId+'&&email='+searchForm.email" style="margin-left:20px">
         <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
        </a>
      </div>
      <div class="searchRight">
        <!-- <el-button size="medium" type="warning" @click="getData"><i class="el-icon-setting" style="margin-right:5px;"></i>提现参数设置</el-button> -->
      </div>
    </div>
    <el-table
      border
      :data="tableData"
      height="73vh"
      style="width: 100%">
      <el-table-column
        width="80px"
        prop="userId"
        label="用户ID">
      </el-table-column>
      <el-table-column
        width="120px"
        prop="phone"
        label="电话">
      </el-table-column>
      <el-table-column
        prop="email"
        width="200px"
        label="邮箱">
      </el-table-column>
      <el-table-column
        width="80px"
        prop="level"
        label="代理等级">
      </el-table-column>
      <el-table-column
        prop="totalPower"
        width="140px"
        label="推广额度(TiB)">
      </el-table-column>
      <el-table-column
        prop="inviteNumber"
        label="好友人数">
      </el-table-column>
      <el-table-column
        prop="effectiveNumber"
        label="有效人数">
      </el-table-column>
      <el-table-column
        prop="inviteIncomeUsdt"
        width="140px"
        label="推广收益(USDT)">
      </el-table-column>
      <el-table-column
        prop="inviteReleasedUsdt"
        width="150px"
        label="已发放收益(USDT)">
      </el-table-column>
      <el-table-column
        prop="inviteFrozenUsdt"
        width="150px"
        label="待发放收益(USDT)">
      </el-table-column>
      <el-table-column
        prop="inviteIncomeFil"
        width="140px"
        label="推广收益(FIL)">
      </el-table-column>
      <el-table-column
        prop="inviteReleasedFil"
        width="140px"
        label="已发放收益(FIL)">
      </el-table-column>
      <el-table-column
        prop="inviteFrozenFil"
        width="150px"
        label="待发放收益(FIL)">
      </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        >
        </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error('输入不能为空'));
      }else {
        if (value !=parseInt(value)) {
          callback(new Error('输入必须为正整数'));
        } else if (value < 0) {
          callback(new Error('输入不能为负值'));
        } else {
          callback();
        }
      }
    };
    var checkNum1 = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error("请输入正确的数值"));
      } else if (value <= 0) {
        callback("输入必须为正数");
      }else {
        callback()
      }
    };
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime()
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000)
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:10,
        phone: '',
        userId: '',
        email:'',
      },
      tableData: [],
      stateOptions: [
        { name: "待审核", value: 0 },
        { name: "已通过", value: 1 },
        { name: "已拒绝", value: 2 },
      ],
      url: window.g.host
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    refuse(id,type) {
      this.$prompt('请输入拒绝原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async ({ value }) => {
        let res = await this.$http.sysUserAudit({id:id,auditStatus:type,rejectReason:value});
        if (res) {
          this.$message({
            type: 'success',
            message: '操作成功'
          });
          this.getTableList()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });       
      });
    },
    upData(id,type) {
      let mag
      if (type == 1) {
        mag = '此操作将认证通过, 是否继续？'
      } else{
        mag = '此操作将拒绝通过, 是否继续？'

      }
      this.$confirm(mag, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let res = await this.$http.sysUserAudit({id:id,auditStatus:type});
        if (res) {
          this.$message({
            type: 'success',
            message: '操作成功!'
          });
          this.getTableList()
        }
        
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
      let res = await this.$http.agentStatisticsHistoryPage({...this.searchForm});
      if (res) {
        this.tableData=res.data.list
        this.totalNum=Number(res.data.totalSize)
      }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
.txt_2{
  margin-bottom: 10px;
}
.txt_3{
  display: inline-block;
  width: 160px;
}
.txt_3:first-child{
  margin-right: 20px;
}
.imgBox{
  width: 200px;
  height: 40px;
}
</style>
<style>
.nodeModules .el-dialog__body{
  padding:0  20px  20px;
}
.nodeModules .el-radio{
  width: 100%;
  margin-bottom: 20px;
}
</style>
